import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconRenditionStyle0 = cosmosIconCss;

const CosmosIconRendition$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRendition extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0e6cf9457e810d89a7c2b221ca6d22325395eba1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '26b5dd749a83e01d9ed8f3278477a79892c44462', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '544b384fac009cb51bdf06dc11787691ba84894b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.05 7.86a.5.5 0 0 0 .07-.59L17 5.23a.5.5 0 0 0-.6-.23l-2.48.58a6.56 6.56 0 0 0-1.36-.78l-.74-2.44a.48.48 0 0 0-.48-.36H9a.49.49 0 0 0-.48.36L7.79 4.8a6.39 6.39 0 0 0-1.37.78L3.94 5a.49.49 0 0 0-.54.23l-1.18 2a.5.5 0 0 0 .07.59L4 9.71a6.27 6.27 0 0 0 0 1.58l-1.71 1.85a.5.5 0 0 0-.07.59l1.18 2a.49.49 0 0 0 .54.23l1.67-.39a.51.51 0 0 0 .39-.45v-3.35a4.15 4.15 0 0 1 .33-3.68 4.38 4.38 0 0 1 8.18 1.47.51.51 0 0 0 .49.44h1.07a.48.48 0 0 0 .39-.19l1.59-1.95Z", fill: "currentColor" }), h("path", { key: '650d57f44f63129e3fe1cd1d2d790e6e7ebbf4ec', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 12h-11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", fill: "#DB0A40" }), h("path", { key: '012be63a70ef66dd9d24db236369a1ae9d4199d1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.501 18.212A4.6 4.6 0 0 1 14 13.5a4.6 4.6 0 0 1 4.499 4.712H9.5Z", fill: "#fff" }), h("path", { key: '7a519cf969837d153ef746bba5ccf23b907f82a0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.596 17.279.281-2.024a.157.157 0 0 0-.27-.113l-1.327 1.552a.18.18 0 0 0 .068.292l.978.45a.191.191 0 0 0 .27-.157Z", fill: "#DB0A40" }))));
    }
    static get style() { return CosmosIconRenditionStyle0; }
}, [1, "cosmos-icon-rendition", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-rendition"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-rendition":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRendition$1);
            }
            break;
    } });
}

const CosmosIconRendition = CosmosIconRendition$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRendition, defineCustomElement };
